import { useEffect, RefObject } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN as string;

export default function AnimatedMapLine({
  id,
  map,
}: {
  id: string;
  map: RefObject<mapboxgl.Map>;
}) {
  useEffect(() => {
    if (!map.current) return;

    // technique based on https://jsfiddle.net/2mws8y3q/
    // an array of valid line-dasharray values, specifying the lengths of the alternating dashes and gaps that form the dash pattern
    const dashArraySequence = [
      [0, 1, 4],
      [0.25, 1, 3.75],
      [0.5, 1, 3.5],
      [0.75, 1, 3.25],
      [1, 1, 3],
      [1.25, 1, 2.75],
      [1.5, 1, 2.5],
      [1.75, 1, 2.25],
      [2, 1, 2],
      [2.25, 1, 1.75],
      [2.5, 1, 1.5],
      [2.75, 1, 1.25],
      [3, 1, 1],
      [3.25, 1, 0.75],
      [3.5, 1, 0.5],
      [3.75, 1, 0.25],
      [4, 1, 0],
      [0, 0.25, 4, 0.75],
      [0, 0.5, 4, 0.5],
      [0, 0.75, 4, 0.25],
    ];

    let step = 0;

    function animateDashArray(timestamp: number) {
      // Update line-dasharray using the next value in dashArraySequence. The
      // divisor in the expression `timestamp / 50` controls the animation speed.
      const animationSpeed = 100;
      const newStep =
        parseInt((timestamp / animationSpeed).toString(), 10) %
        dashArraySequence.length;
      if (newStep !== step) {
        // Add check to ensure layer exists before updating
        if (map.current?.getLayer(id)) {
          map.current?.setPaintProperty(
            id,
            "line-dasharray",
            dashArraySequence[step]
          );
          step = newStep;
        }
      }
      // Request the next frame of the animation.
      requestAnimationFrame(animateDashArray);
    }
    // start the animation
    animateDashArray(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return null;
}
